import script from "./CreateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAutomationDialog.vue?vue&type=style&index=0&id=84c1a704&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84c1a704"]])